// extracted by mini-css-extract-plugin
export default {"root":"BkLDC0HPNh"};